export const WEBSOCKET_URL = window._env_.VITE_WEBSOCKET_URL;
